import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { CMSPortalService } from '../shared/service/cms-portal.service';
import { Video } from '../shared/model/video.model';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css']
})
export class VideosComponent implements OnInit {

  @ViewChild('listaVideos') listaVideosEL: ElementRef;
  @Input() limit = 0;
  videos: Array<Video>;

  constructor(private service: CMSPortalService,
              private router: Router,
              private http: HttpClient) { }

  ngOnInit(): void {
    this.buscarVideos();
  }

  buscarVideos() {
    this.service.getVideos().subscribe(res => {
      const conteudo: Array<Video> = res.conteudo;
      if (this.limit > 0 && conteudo != null && conteudo.length > this.limit) {
        this.videos = conteudo.slice(0, this.limit);
      } else {
        this.videos = conteudo;
        setTimeout(() => {
          this.carregarPaginacao();
        }, 100);
      }
    });
  }

  carregarPaginacao() {
    this.http.get('content/js/pagination-video.js', {responseType: 'text'}).subscribe(file => {
      const js = '<script type="text/javascript">' +
                    file +
                  '</script>';
      const fragment = document.createRange().createContextualFragment(js);
      this.listaVideosEL.nativeElement.appendChild(fragment);
    });
  }

  buscarCapaYoutube(video: Video): string {
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = video.url.match(regExp);
    if (match && match[2].length === 11) {
      return `http://i1.ytimg.com/vi/${match[2]}/default.jpg`;
    } else {
      return '/assets/img/untitled.png';
    }
  }

  abrirVideo(video: Video) {
    this.router.navigate(['/video', video.id]);
  }

}
